import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import $ from 'jquery';
import DropDownCellCorrelativa from './myDropDownCellCorrelativa';
import { auto } from '@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core';
// export const DropDownCellProduto = props => {
  
  var optionsCapacidades = [];
  var DropDownCellTipoVasilha = null;

  var IdCorrelativas = null;
  var thisState;
myFunction()
function myFunction() {
  (async () => {
    optionsCapacidades = [];
    if($('#instal_vinica_auto').val() != '' & $('#instal_vinica_auto').val() != null){
      const data = {}
      const ProdutoList = await services.apiCall.requestApi(
          "/Receita/GetTipoFatura",
          data,
          "get"
      );
      
      if(ProdutoList){
        ProdutoList.map((Produto) => (
          optionsCapacidades.push({text: Produto.descricao, 
                                  value: Produto.idTipoFatura})
        ));
      }
      thisState.setState({ datatav: 1 }); 
    }
})();};

class DropDownCellDocumentos extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: null,
      datatav: null
    };
  }


  handleChange = e => {
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
    });
  }

  componentDidMount = () => {
    thisState = this;
    (async () => {
      optionsCapacidades = [];
      if($('#instal_vinica_auto').val() != '' & $('#instal_vinica_auto').val() != null){
        const data = {}
        const ProdutoList = await services.apiCall.requestApi(
            "/Receita/GetTipoFatura",
            data,
            "get"
        );
        
        if(ProdutoList){
          ProdutoList.map((Produto) => (
            optionsCapacidades.push({text: Produto.descricao, 
                                    value: Produto.idTipoFatura})
          ));
        }
        this.setState({ datatav: 1 }); 
      }
  })()
    this.setState({ datatav: 1 }); 
  }

  render() {

    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';

    const dataValue = dataItem[field] === null ? '' : dataItem[field];

    if(dataItem.idDocumento != undefined && dataItem.idDocumento != null && optionsCapacidades.length> 0){
      var dataEnter = optionsCapacidades.find(c => c.value === (dataItem.idDocumento))
    }

    return (
        <td>
            {dataItem.inEdit ?
            <DropDownList
                popupSettings={{
                  width: 'max-content',
                }}
                onChange={this.handleChange}
                value={optionsCapacidades.find(c => c.value === (dataValue != null ? dataValue.value != null ? dataValue.value :dataValue : null))}
                data={optionsCapacidades}
                textField="text"
                id='id-DropDownCellCapacidades'
            />
            : dataValue != null && dataValue !== "" && dataValue !== undefined  ? dataValue.text.toString() : dataEnter != null ? dataEnter.text  : undefined}
        </td>
    );
  }
}

export default DropDownCellDocumentos;